import { useCallback } from 'react'

import {
  DEFAULT_CAMERA_POSITION,
  DEFAULT_CAMERA_TARGET,
} from 'Pods/ThreeDStudio/constants'
import useUpdateSessionSettings from 'Pods/ThreeDStudio/Hooks/useUpdateSessionSettings'
import { useViewerStore } from 'Pods/ThreeDStudio/Hooks/useViewerStore'
import { useViewerContext } from 'Pods/ThreeDStudio/Shared/ViewerContext/ViewerContext'

function useViewerControls() {
  const viewer = useViewerContext()
  const grid = useViewerStore(viewer, 'grid')
  const camera = useViewerStore(viewer, 'camera')
  const updateSessionSettings = useUpdateSessionSettings()

  // Grid and auto-rotate are session-ephemeral, always-default viewer flags:
  // toggling them updates the live viewer only and never persists, so a model
  // swap re-asserts the default (see applyInitialSettings).
  const toggleGrid = useCallback(() => {
    const next = !grid?.visible
    viewer?.setGridSettings({ visible: next })
  }, [viewer, grid])

  const toggleAutoRotate = useCallback(() => {
    const next = !camera?.autoRotate
    viewer?.setCameraSettings({ autoRotate: next })
  }, [viewer, camera])

  const resetCamera = useCallback(() => {
    viewer?.resetCamera()
    viewer?.setCameraSettings({ autoRotate: false })
    updateSessionSettings({
      cameraPosition: DEFAULT_CAMERA_POSITION,
      cameraTarget: DEFAULT_CAMERA_TARGET,
    })
  }, [viewer, updateSessionSettings])

  return {
    grid,
    camera,
    toggleGrid,
    toggleAutoRotate,
    resetCamera,
  }
}

export default useViewerControls
